import { render, staticRenderFns } from "./ProfileHeader.vue?vue&type=template&id=c9953d20&scoped=true"
import script from "./ProfileHeader.vue?vue&type=script&lang=js"
export * from "./ProfileHeader.vue?vue&type=script&lang=js"
import style0 from "./ProfileHeader.vue?vue&type=style&index=0&id=c9953d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9953d20",
  null
  
)

export default component.exports